import { render } from "./modal_openform.vue?vue&type=template&id=47dae411&scoped=true"
import script from "./modal_openform.vue?vue&type=script&lang=js"
export * from "./modal_openform.vue?vue&type=script&lang=js"

import "./modal_openform.vue?vue&type=style&index=0&id=47dae411&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47dae411"]])

export default __exports__